import { render, staticRenderFns } from "./CloseStore.vue?vue&type=template&id=036b79c8"
import script from "./CloseStore.vue?vue&type=script&lang=js"
export * from "./CloseStore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports